// extracted by mini-css-extract-plugin
export default {"compressed":"UserAvatarGroup_compressed__5-y7l"};